import { useEffect, useState } from "react";
import Modal from "../modal/modal";

const Get_Companies = () => {
  const [companies, setCompanies] = useState([]);
  const [search, setSearch] = useState("");
  const [modalMessage, setModalMessage] = useState(null); // { id, title, text }

  const fetchCompanies = () => {
    fetch("/api/get_companies.php")
      .then((res) => res.json())
      .then((data) => {
        if (data.success) setCompanies(data.companies);
      });
  };

  useEffect(() => {
    fetchCompanies();
  }, []);

  // Вызываем модалку для подтверждения удаления
  const confirmDelete = (id, companyName) => {
    setModalMessage({
      id,
      title: "Ցանկանում եք ջնջել այս կազմակերպությունը?",
      text: `Դուք ջնջելու եք կազմակերպությունը "${companyName}"`,
      actions: [
      {
        label: "Ջնջել",
        success: true,
        onClick: () => handleDelete(id),
      },
      {
        label: "Չեղարկել",
        success: false,
        onClick: () => setModalMessage(null),
      },
    ],
    });
  };

  const handleDelete = (id) => {
    fetch(`/api/delete_company.php?id=${id}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setCompanies((prev) => prev.filter((c) => c.id !== id));
        } else {
          alert("Անհաջող ջնջում: " + data.message);
        }
      })
      .catch((err) => alert("Սխալ: " + err))
      .finally(() => setModalMessage(null));
  };

  const filtered = companies.filter((c) => {
    const s = search.toLowerCase();
    const name = (c.companyName ?? "").toLowerCase();
    const hvhh = (c.hvhh ?? "").toLowerCase();
    const email = (c.email ?? "").toLowerCase();
    const packages = "—";

    return (
      c.id.toString().includes(s) ||
      name.includes(s) ||
      hvhh.includes(s) ||
      email.includes(s) ||
      packages.includes(s)
    );
  });

  return (
    <section className="px-3 sm:px-4 md:px-6">
      {/* Модалка */}
      {modalMessage && (
        <Modal
          title={modalMessage.title}
          text={modalMessage.text}
          actions={modalMessage.actions}
        />
      )}

      {/* Заголовок и поиск */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-4 mb-4 sm:mb-6">
        <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white">
          Կազմակերպությունների բազա
        </h1>

        <input
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Որոնում..."
          className="w-full sm:w-72 px-4 py-2 rounded-lg bg-white/10 text-white placeholder-white/40 
                     border border-white/20 focus:outline-none focus:border-white 
                     transition text-sm sm:text-base"
        />
      </div>

      {/* Десктопная таблица */}
      <div className="hidden md:block overflow-x-auto rounded-lg border border-white/20 backdrop-blur-xl">
        <table className="min-w-full text-white border-collapse">
          <thead>
            <tr className="bg-white/10">
              <th className="py-3 px-4 border border-white/20 text-left">ID</th>
              <th className="py-3 px-4 border border-white/20 text-left">Կազմակերպության անվանումը</th>
              <th className="py-3 px-4 border border-white/20 text-left">ՀՎՀՀ</th>
              <th className="py-3 px-4 border border-white/20 text-left">Էլ․ հասցե</th>
              <th className="py-3 px-4 border border-white/20 text-left">Փաթեթներ</th>
              <th className="py-3 px-4 border border-white/20 text-left">Գործողություններ</th>
            </tr>
          </thead>

          <tbody>
            {filtered.map((c) => (
              <tr
                key={c.id}
                className="hover:bg-white/5 transition border border-white/10"
              >
                <td className="py-3 px-4 border border-white/10">{c.id}</td>
                <td className="py-3 px-4 border border-white/10">{c.companyName}</td>
                <td className="py-3 px-4 border border-white/10">{c.hvhh}</td>
                <td className="py-3 px-4 border border-white/10">{c.email}</td>
                <td className="py-3 px-4 border border-white/10">—</td>
                <td className="py-3 px-4 border border-white/10">
                  <button
                    onClick={() => confirmDelete(c.id, c.companyName)}
                    className="px-3 py-1 bg-red-600/50 hover:bg-red-600 rounded-lg border border-red-400/30 transition"
                  >
                    ջնջել
                  </button>
                </td>
              </tr>
            ))}

            {filtered.length === 0 && (
              <tr>
                <td colSpan="6" className="py-4 px-4 text-center text-white/50 border border-white/20">
                  Ոչինչ չի գտնվել
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Мобильные карточки */}
      <div className="md:hidden space-y-3">
        {filtered.map((c) => (
          <div
            key={c.id}
            className="bg-white/5 rounded-lg border border-white/20 p-4 space-y-2"
          >
            <div className="flex justify-between items-start gap-2">
              <span className="text-xs text-white/60">ID: {c.id}</span>
              <span className="text-xs text-white/60">Փաթեթներ: —</span>
            </div>
            
            <h3 className="text-white font-medium text-sm sm:text-base break-words">
              {c.companyName}
            </h3>
            
            <div className="space-y-1">
              <p className="text-white/70 text-xs sm:text-sm">
                <span className="text-white/50">ՀՎՀՀ: </span>
                {c.hvhh || "—"}
              </p>
              <p className="text-white/70 text-xs sm:text-sm break-all">
                <span className="text-white/50">Էլ․ հասցե: </span>
                {c.email || "—"}
              </p>
            </div>
            
            <button
              onClick={() => confirmDelete(c.id, c.companyName)}
              className="w-full px-3 py-2 bg-red-600/50 hover:bg-red-600 rounded-lg border border-red-400/30 transition text-white text-sm"
            >
              ջնջել
            </button>
          </div>
        ))}

        {filtered.length === 0 && (
          <div className="text-center text-white/50 py-8 bg-white/5 rounded-lg border border-white/20">
            Ոչինչ չի գտնվել
          </div>
        )}
      </div>
    </section>
  );
};

export default Get_Companies;